type MemoryCandidateToast = (options: { title: string }) => void

type QueryClientLike = {
  invalidateQueries: (options: { queryKey: string[] }) => Promise<unknown> | unknown
}

type DismissSuccessOptions = {
  queryClient: QueryClientLike
  setHidden: (value: boolean) => void
  toast: MemoryCandidateToast
  toastTitle: string
}

export async function handleDismissMemoryCandidateSuccess({
  queryClient,
  setHidden,
  toast,
  toastTitle,
}: DismissSuccessOptions): Promise<void> {
  await queryClient.invalidateQueries({ queryKey: ["memories"] })
  setHidden(true)
  toast({ title: toastTitle })
}
